// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"9bfc646a4f244ee45fab","293":"9cae3088131386e91b67","518":"2ab9b5fb3e14f1a096c3","779":"6b30e91e1e6dd95398f1"}[chunkId] + ".js";
};